@if (!imgTag && !includesAudioTag()) {
  <div class="container md-head head-marg-top">
    @if ((wording ||instruction) && isReadable()) {
      <div
        #readMe
        (speaking)="speakStateChanged($event)"
        [autoRead]="autoRead"
        [instructionAudio]="instructionAudio"
        [ngClass]="{
            'tts': true,
            'wording': true,
            'tts-reading': isTTSSpeaking,
            'is-instruction': !!instruction && !imgTag
            }"
        [wordingAudio]="wordingAudio"
        appReadable
        [activateDirective]="isTtsActive()"
        >
        @if (wording && isReadable()) {
          <div
            [innerHtml]="wording | stringToHtml"
            [ngClass]="{'wording': true, 'tts-reading': isTTSSpeaking }"
            [appDayRelativeNameToString]="{language_key: language}"
            [appTimeSlotToString]="{language_key: language}"
            class="bem-consignes__content"
          ></div>
        }
        @if (instructionUpdated) {
          <div
            [innerHtml]="instructionUpdated | stringToHtml"
            [ngClass]="{
                'instruction': true,
                'tts-reading': isTTSSpeaking,
                'is-picture': imgTag,
                'is-video': instruction.includes('<video')
            }"
            [appDayRelativeNameToString]="{language_key: language}"
            [appTimeSlotToString]="{language_key: language}"
            class="bem-consignes__content"
            >
          </div>
        }
        @if (additionalHiddenText && additionalHiddenText!=='' && isReadable()) {
          <span
            [appDayRelativeNameToString]="{language_key: language}"
            [appTimeSlotToString]="{language_key: language}"
          class="precision">{{additionalHiddenText}}</span>
        }
        @if ((wordingAudio && wordingAudio!=='') || (instruction && !imgTag)) {
          <mat-icon
            [svgIcon]="isTTSSpeaking?'sound_on':'sound_off'"
            #tooltip="matTooltip"
            [matTooltip]="'activities.lesson.listen' | translate">
          </mat-icon>
        }
      </div>
    }
    @if (wording && !isReadable()) {
      <div
        [innerHtml]="wording | stringToHtml"
        [appDayRelativeNameToString]="{language_key: language}"
        [appTimeSlotToString]="{language_key: language}"
      class="wording bem-consignes__content"></div>
    }
    @if (instruction && !isReadable()) {
      <div
        [elementToWatch]="instruction"
        [innerHtml]="instruction | stringToHtml"
        appAddClassIfContainsPicture
        [appDayRelativeNameToString]="{language_key: language}"
        [appTimeSlotToString]="{language_key: language}"
      class="instruction bem-consignes__content"></div>
    }
  </div>
}

@if (imgTag && imgTag !== '') {
  <div
    class="container consigne-img consignes__image"
    [attr.id]="'consigneImg' + uuid">
    <div class="consignes__content"
         [ngClass]="{'instruction': !this.fullscreenService.isFullscreenImageActive,
                     'is-picture': !this.fullscreenService.isFullscreenImageActive,
                     'fullscreen': this.fullscreenService.isFullscreenImageActive}"
      [innerHtml]="imgTag | stringToHtml">
    </div>
    @if (isImageFullscreenButtonActive()) {
      <div
        class="action-buttons consignes__actions">
        @if (!this.fullscreenService.isFullscreenImageActive) {
          <mat-icon
            class="consignes__expand-icon"
            svgIcon="image__button-fullscreen"
            [matTooltip]="'activities.lesson.display' | translate"
            role="button"
            (click)="this.fullscreenService.openFullscreen('consigneImg' + uuid)">
          </mat-icon>
        }
      </div>
    }
  </div>
}

<!-- If instruction includes an audio tag -->
@if (includesAudioTag()) {
  <div
    class="consignes__audio-player">
    <mat-icon class="consignes__audio-icon"
      svgIcon="speaker-equalizer">
    </mat-icon>
    <div class="consignes__audio-wrapper"
      [innerHtml]="instruction | stringToHtml">
    </div>
  </div>
}